import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import get from 'lodash/get';
import ResourceItem from '../ResourceItem';
import RightContentLayout from '../layout/RightContentLayout';
import BodyContentLayout from '../layout/BodyContentLayout';
import LeftContentLayout from '../layout/LeftContentLayout';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';

const PracticeProblem = ({
  getResourceActions,
  resources = [],
  showRightContent = true,
  showResourceContent = false,
  getIcons,
  getSppAssignments,
  onTitleClicked = () => {},
}) => {
  const styles = cn({ 'desktop:w-full': !showRightContent });
  return (
    <BodyContentLayout>
      {showRightContent && (
        <RightContentLayout title="Student Practice" showIcon icon="spp" />
      )}

      <LeftContentLayout layoutClassName={styles}>
        {resources.map((resource) => {
          const { displayName, assessmentId, description, resourceId } =
            resource;
          const resourcesActions = getResourceActions(resource);
          const sppAssignments = getSppAssignments(resourceId, assessmentId);
          const onlySandbox = (sppAssignments || []).length === 1;
          const score = get(
            onlySandbox ? sppAssignments : null,
            '[0].score',
            0,
          );
          const maxScore = get(
            onlySandbox ? sppAssignments : null,
            '[0].maxScore',
            0,
          );
          const decimalScore = maxScore ? score / maxScore : 0;
          const learnosityActivityId = get(
            onlySandbox ? sppAssignments : null,
            '[0].learnosityActivityId',
            '',
          );
          const icons = getIcons(
            assessmentId,
            learnosityActivityId,
            resourceId,
            decimalScore,
          );

          const resourceContent = (
            <Fragment>
              <div className="text-2xl font-medium">{displayName}</div>
              <div className="text-base mt-1">{description}</div>
            </Fragment>
          );

          const action = <div className="ml-auto pl-5">{resourcesActions}</div>;

          return showResourceContent ? (
            <ResourceItem
              key={`progres-check-${assessmentId}`}
              iconName="label"
              iconClassName="fill-current text-teal"
              className="hover:bg-blue-100"
            >
              <AccessibilityWrapper>
                <div
                  className={cn('flex-1 hover:text-black text-black', {
                    'hover:underline cursor-pointer': !!resourcesActions,
                  })}
                  {...(!!resourcesActions
                    ? {
                        role: 'link',
                        tabIndex: '0',
                        onClick: (e) =>
                          onTitleClicked(e, resource, assessmentId),
                      }
                    : {
                        style: { cursor: 'initial' },
                      })}
                >
                  {resourceContent}
                </div>
              </AccessibilityWrapper>
              {icons}
              {action}
            </ResourceItem>
          ) : (
            <Fragment>{action}</Fragment>
          );
        })}
      </LeftContentLayout>
    </BodyContentLayout>
  );
};

PracticeProblem.displayName = 'PracticeProblem';

PracticeProblem.propTypes = {
  getResourceActions: PropTypes.func.isRequired,
  resources: PropTypes.array.isRequired,
  getIcons: PropTypes.func,
  getSppAssignments: PropTypes.func,
};

PracticeProblem.defaultProps = {
  getResourceActions: () => {},
  resources: [],
  getIcons: () => {},
  getSppAssignments: () => {},
};

export default PracticeProblem;
